// API Configuration
export const CLIENT_URL = 'https://travley.in'

// Core Services - Production URLs
export const auth = "https://auth.travley.in"
export const maps = "https://atlas.travley.in"
export const tour = "https://tour.travley.in"
export const train = "https://train.travley.in"
export const metro = "https://metro.travley.in"
export const room = "https://room.travley.in"

// Task Management System
export const task = "https://task.travley.in"
export const brevo = "https://mail.travley.in"

// AI Assistant
export const agent = "https://ai.travley.in"

// External APIs
export const base = "https://api.openweathermap.org/data/2.5"

// OAuth Configuration
export const client_id = "493238715849-k1bmslg0qh2rvkfukppincdqd7nhf0ma.apps.googleusercontent.com"
export const client_id_ = "0627ece64d2d4a109afa57ec9618d1e5"
export const callback = "https://travley.in/callback"

// API Keys
export const weatherAPIKey = "bd5e378503939ddaee76f12ad7a97608"
export const key = "CiIYTuCeWC0ONFxXmNPOxfF5fKg2DX4D"
export const key_ = "8e99f9a8aa2321a2a214314641e644c3"

// reCAPTCHA v3 Configuration (Invisible)
export const recaptchaSiteKey = "6LeXpmIrAAAAAFILfMYqpSH_my6Qvoa31fUgljNY"

// Rate Limiting Configuration
export const rateLimits = {
  // Task Management Rate Limits
  remindersPerDay: 10,           // Maximum reminders per day per user
  tasksPerHour: 10,            // Maximum tasks per hour per user
  tasksPerDay: 50,             // Maximum tasks per day per user

  // Authentication Rate Limits
  otpAttemptsPerHour: 5,       // Maximum OTP attempts per hour
  loginAttemptsPerDay: 20,     // Maximum login attempts per day

  // API Rate Limits
  apiCallsPerMinute: 60,       // Maximum API calls per minute per user
  apiCallsPerHour: 1000,       // Maximum API calls per hour per user

  // Search Rate Limits
  searchRequestsPerMinute: 30, // Maximum search requests per minute

  // Email Rate Limits
  emailsPerDay: 10,            // Maximum emails per day per user

  // Rate Limit Window (in hours)
  windowHours: 24              // Default rate limit window
}



